export default {
  "active": "Active",
  "expired": "Expired",
  "missing": "Missing",
  "loadingCertificates": "Loading certificates...",
  "noCertificatesInstalled": "No certificates installed",
  "issueACertificateToGetStartedWithSSLTLS": "Issue a certificate to get started with SSL/TLS.",
  "domain": "Domain",
  "status": "Status",
  "expires": "Expires",
  "target": "Target",
  "actions": "Actions",
  "renewCertificate": "Renew certificate",
  "removeCertificate": "Remove certificate",
  "domainIsRequired": "Domain is required",
  "invalidDomainFormat": "Invalid domain format",
  "wildcardDomainsRequireDNSChallenge": "Wildcard domains require DNS challenge",
  "targetIsRequired": "Target is required",
  "dNSProviderIsRequiredForDNSChallenge": "DNS provider is required for DNS challenge",
  "allCredentialFieldsAreRequired": "All credential fields are required",
  "credentialsSaved": "Credentials saved",
  "loadingTargets": "Loading targets...",
  "selectATarget": "Select a target...",
  "chooseWhichServiceToIssueTheCertificateFor": "Choose which service to issue the certificate for.",
  "exampleComOrExampleCom": "example.com or *.example.com",
  "theDomainNameForTheCertificateUseDomainComFor": "The domain name for the certificate. Use *.domain.com for wildcards (requires DNS challenge).",
  "challengeMethod": "Challenge Method",
  "challengeMethod2": "Challenge method",
  "port80WebrootVerification": "Port 80 webroot verification",
  "dNSRecordVerificationWildcards": "DNS record verification (wildcards)",
  "dNSProvider": "DNS Provider",
  "selectDNSProvider": "Select DNS provider...",
  "checkingCredentials": "Checking credentials...",
  "update": "Update",
  "saving": "Saving...",
  "saveCredentials": "Save Credentials",
  "cancel": "Cancel",
  "theseCredentialsAreStoredInTheAcmeShEnvironmentOn": "These credentials are stored in the acme.sh environment on the server. See your DNS provider's API documentation for details.",
  "username": "Username",
  "systemUsername": "System username",
  "issuing": "Issuing...",
  "issueCertificate": "Issue Certificate",
  "queued": "Queued",
  "running": "Running",
  "succeeded": "Succeeded",
  "failed": "Failed",
  "cancelled": "Cancelled",
  "issuingCertificate": "Issuing Certificate",
  "renewingCertificate": "Renewing Certificate",
  "removingCertificate": "Removing Certificate",
  "jobOutput": "Job output",
  "jobCancelled": "Job cancelled.",
  "operationCompletedSuccessfully": "Operation completed successfully.",
  "dismiss": "Dismiss",
  "failedToLoadCertificates": "Failed to load certificates",
  "failedToFetchJobStatus": "Failed to fetch job status",
  "failedToIssueCertificate": "Failed to issue certificate",
  "issueFailed": "Issue failed",
  "certificateIssuanceStarted": "Certificate issuance started",
  "networkError": "Network error",
  "failedToRenewCertificate": "Failed to renew certificate",
  "renewalFailed": "Renewal failed",
  "certificateRenewalStarted": "Certificate renewal started",
  "failedToRemoveCertificate": "Failed to remove certificate",
  "removalFailed": "Removal failed",
  "certificateRemovalStarted": "Certificate removal started",
  "failedToLoadTargets": "Failed to load targets",
  "failedToLoadSSLTargets": "Failed to load SSL targets",
  "renewCertificate2": "Renew Certificate",
  "removeCertificate2": "Remove Certificate",
  "sSLControl": "SSL Control",
  "manageLetSEncryptSSLTLSCertificatesForYourServer": "Manage Let's Encrypt SSL/TLS certificates for your server and applications.",
  "total": "Total",
  "expiringSoon": "Expiring Soon",
  "errorLoadingCertificates": "Error loading certificates",
  "issueNewCertificate": "Issue New Certificate",
  "configureAndIssueALetSEncryptSSLCertificate": "Configure and issue a Let's Encrypt SSL certificate",
  "installedCertificates": "Installed Certificates",
  "sSLTLSCertificatesManagedByLetSEncrypt": "SSL/TLS certificates managed by Let's Encrypt",
  "cLIReference": "CLI Reference",
  "certificatesCanAlsoBeManagedViaTheQuickBoxCLI": "Certificates can also be managed via the QuickBox CLI:",
  "fullLecertDocumentation": "Full Lecert documentation",
  "expiryExpired": "{{date}} (expired)",
  "expiryDays": "{{date}} ({{remaining}})",
  "renewDomain": "Renew certificate for {{domain}}",
  "removeDomain": "Remove certificate for {{domain}}",
  "usernameRequired": "Username is required for {{target}}",
  "credentialsSavedFor": "DNS credentials for {{provider}} saved successfully",
  "targetNotInstalled": "{{target}} (not installed)",
  "credentialsFoundFor": "Credentials found for {{provider}}",
  "foundKeys": "Found: {{keys}}",
  "updateCredentialsFor": "Update credentials for {{provider}}",
  "enterCredentialsFor": "Enter credentials for {{provider}}",
  "systemUserFor": "The system user that {{target}} is installed under.",
  "thisApp": "this app",
  "jobIdentity": "{{domain}} — Job {{jobId}}",
  "issueDomain": "Issuing certificate for {{domain}}",
  "renewingDomain": "Renewing certificate for {{domain}}",
  "removingDomain": "Removing certificate for {{domain}}",
  "renewConfirm": "Force renewal of the certificate for {{domain}}? This will request a new certificate from Let's Encrypt.",
  "removeConfirm": "Are you sure you want to remove the certificate for {{domain}}? This will delete the certificate files and associated nginx configuration. This action cannot be undone.",
  "renew": "Renew",
  "remove": "Remove",
  "backendDashboard": "Dashboard",
  "backendStandalone": "Standalone (No Dashboard)",
  "backendAdminRequired": "Admin privileges required",
  "backendInternalError": "Internal server error",
  "backendInvalidDomain": "Invalid domain format",
  "backendCertificateNotFound": "Certificate not found",
  "backendInvalidCsrf": "Invalid CSRF token",
  "backendInvalidBody": "Invalid request body",
  "backendBusy": "An SSL operation is already in progress (job {{jobId}}: {{action}} {{domain}}). Please wait for it to complete.",
  "backendIssuing": "Issuing certificate for {{domain}}",
  "backendRenewing": "Renewing certificate for {{domain}}",
  "backendRemoving": "Removing certificate for {{domain}}",
  "backendInvalidJobId": "Invalid job ID",
  "backendJobNotFound": "Job not found",
  "backendInvalidProviderId": "Invalid provider ID",
  "backendUnknownProvider": "Unknown DNS provider",
  "backendMissingCredentials": "Missing required credentials: {{keys}}",
  "backendNoCredentials": "No valid credentials provided",
  "backendSaveFailed": "Failed to save credentials",
  "backendCertificateMissingDetail": "Process exited successfully but certificate was not created: {{detail}}",
  "backendCertificateMissing": "Process exited successfully but certificate was not created — check logs for details",
  "backendJobFailedDetail": "{{action}} failed (exit {{exit}}): {{detail}}",
  "backendJobFailed": "{{action}} failed with exit code {{exit}}",
  "backendAborted": "Aborted by user",
  "backendDomainFormat": "{{field}}: Invalid domain name format",
  "backendUnsupportedTarget": "{{field}}: Unsupported SSL target: {{target}}",
  "backendWildcardDns": "{{field}}: Wildcard domains require DNS challenge method",
  "backendProviderRequired": "{{field}}: DNS provider is required when using DNS challenge",
  "backendUnsupportedProvider": "{{field}}: Unsupported DNS provider: {{provider}}",
  "backendUsernameRequired": "{{field}}: Username is required for target \"{{target}}\"",
  "backendCredentialKey": "{{field}}: Invalid credential key format",
  "backendCredentialEmpty": "{{field}}: Credential value cannot be empty",
  "backendCredentialLong": "{{field}}: Credential value too long",
  "backendCredentialRequired": "{{field}}: At least one credential is required",
  "backendRequired": "{{field}}: A value is required",
  "backendExpectedString": "{{field}}: A text value is required",
  "backendExpectedObject": "{{field}}: An object is required",
  "backendExpectedBoolean": "{{field}}: A boolean value is required",
  "backendMinLength": "{{field}}: Minimum length: {{bound}}",
  "backendMaxLength": "{{field}}: Maximum length: {{bound}}",
  "backendChallengeChoice": "{{field}}: Choose http or dns",
  "backendActionIssue": "Issuance",
  "backendActionRenew": "Renewal",
  "backendActionRemove": "Removal",
  "connectionLostCertificateSwapped": "This tab lost its connection, most likely because the dashboard certificate was just replaced. Open {{link}} to see the result.",
  "connectionLostRetrying": "Lost connection to the dashboard. Still retrying."
} as const;
